import React from 'react';
import PropTypes from 'prop-types';
import messages from './messages';
import { FormattedMessage } from 'react-intl';

const SaveBookmarkButton = props => (
  <div className="afd-saved-in">
    <a
      className="js-myad-fav afd-icon-text afd-icon-text--pmyad afd-save-item clearfix"
      href="#"
      data-image={props.image}
      data-status={props.status}
      data-title={props.title}
      data-url={props.url}
    >
      <i className="afd-icon afd-icon-text__icon afd-icon--icon-folder-blue" />
      <span className="afd-fl">
        <FormattedMessage {...messages.saveThis} /> <FormattedMessage {...messages[props.type]} />
      </span>
    </a>
  </div>
);

SaveBookmarkButton.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default SaveBookmarkButton;
